import * as ActionTypes from '../../../constants/setting/blog'
import update from 'immutability-helper'

const initialState = {}

export default (state = initialState, action) => {
	switch(action.type) {
		case ActionTypes.RECEIVE_SETTINGS:
			return action.settings.info

		case ActionTypes.RECEIVE_INFO:
			return action.info

    case ActionTypes.CHANGE_BLOG_VISIBILITY:
      return update(state, {
        visibility: {
          $set: action.visibility
        }
      })

		default:
			return state
	}
}
